module.exports = __parcel__import__.meta.resolve("4y25U");